import { Component } from '@angular/core';

@Component({
  selector: 'mprd-epress-confirmation-modal',
  templateUrl: './epress-confirmation-modal.component.html',
  styleUrls: ['./epress-confirmation-modal.component.css'],
})
export class EpressConfirmationModalComponent {
  title: string;
  description: string;
  confirmButtonLabel: string;
  cancelButtonLabel: string;
  jsonProduct: string;

  destroy: Function;
  confirm: Function;

  constructor() {}

  confirmSwap() {
    if (this.confirm) {
      this.confirm();
    }
    this.destroy();
  }

  close() {
    this.destroy();
  }
}
